import { ShieldCheck } from 'lucide-react';
import type { AdminCompanyStaff } from 'app/javascript/types/admin';
import HealthPanel from 'app/javascript/components/admin/company_health/HealthPanel';
import StaffRow from 'app/javascript/components/admin/company_health/StaffRow';
import { Empty, EmptyHeader, EmptyTitle, EmptyDescription } from 'app/javascript/components/ui/empty';

// Who runs this academy. Leads the page because an owner who cannot get into
// the app explains every other number below it.
export default function StaffPanel({ staff }: { staff: AdminCompanyStaff[] }) {
  return (
    <HealthPanel
      icon={<ShieldCheck className="size-4" />}
      title="Quem administra"
      action={
        staff.length > 0 && (
          <span className="text-xs text-muted-foreground">
            {staff.length} {staff.length === 1 ? 'pessoa' : 'pessoas'}
          </span>
        )
      }
      contentClassName="px-4 py-1"
    >
      {staff.length === 0 ? (
        <Empty>
          <EmptyHeader>
            <EmptyTitle>Sem responsáveis</EmptyTitle>
            <EmptyDescription>Nenhum dono ou administrador aceito. Ninguém consegue gerenciar esta academia.</EmptyDescription>
          </EmptyHeader>
        </Empty>
      ) : (
        <div className="divide-y divide-border">
          {staff.map((member) => (
            <StaffRow key={member.id} member={member} />
          ))}
        </div>
      )}
    </HealthPanel>
  );
}
